import { createElement, installComponent } from '../utils/createElement';
import { BREAKPOINTS } from '../utils/breakpoints';
import { COLOR_GRAY_BASE, COLOR_WHITE, COLOR_BLACK } from '../utils/colors';

export default class SideNavLoadingLink extends HTMLElement {
  constructor() {
    super();

    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    const skeleton = createElement('div', { class: 'sb-sidenav-loading-link__skeleton' });
    this.loadingRoot = createElement('div', { class: 'sb-sidenav-loading-link' }, [skeleton]);

    const styles = createElement('style', null, `
      .sb-sidenav-loading-link {
        width: 256px;
        padding: 0.625rem 1.875rem;
        box-sizing: border-box;
        background-color: ${COLOR_GRAY_BASE};
        animation-fill-mode: forwards;
      }
      .sb-sidenav-loading-link--remove {
        animation: remove 500ms linear;
        animation-fill-mode: forwards;
      }
      .sb-sidenav-loading-link__skeleton {
        border-radius: 3px;
        height: 25px;
        width: 100%;

        animation: loading 1.5s infinite;

        background-color: ${COLOR_WHITE}5e;
        background-image: linear-gradient(90deg, transparent 0px, ${COLOR_BLACK}21 20px, ${COLOR_BLACK}21 80px, transparent 100px);
        background-size: 224px 26px;
        background-repeat: no-repeat;
        background-position: center;
      }
      @media only screen and (max-width: ${BREAKPOINTS.lg}px) and (min-width: ${BREAKPOINTS.md}px) {
        .sb-sidenav-loading-link {
          padding: 0.625rem .875rem;
          width: 60px;
        }
        .sb-sidenav-loading-link__skeleton  {
          animation: loading-small 1.5s infinite;
        }
      }

      @keyframes remove {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
          height: auto;
          padding: 0.625rem 1.875rem;
        }
        51% {
          height: 0;
          padding: 0;
        }
        100% {
          opacity: 0;
          height: 0;
          padding: 0;
        }
      }
      @keyframes loading {
        0% {
          background-position: 1000% 50%;
        }
        100% {
          background-position: -1000% 50%;
        }
      }
      @keyframes loading-small {
        0% {
          background-position: 100% 50%;
        }
        100% {
          background-position: -100% 50%;
        }
      }
    `);

    this.shadowRoot.append(this.loadingRoot, styles);
  }
}
installComponent('sb-sidenav-loading-link', SideNavLoadingLink);
